var _path, _path2, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllSet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 112.139C87.3757 112.139 112 87.5151 112 57.1394C112 26.7637 87.3757 2.1394 57 2.1394C26.6243 2.1394 2 26.7637 2 57.1394C2 87.5151 26.6243 112.139 57 112.139Z",
    fill: "white",
    stroke: "#05C3DE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0455 64.88V64.88C77.9353 64.88 79.4649 66.4058 79.4649 68.2908C79.4649 70.1759 77.9353 71.7016 76.0455 71.7016H73.766C75.6557 71.7016 77.1853 73.2274 77.1853 75.1124C77.1853 76.9974 75.6557 77.3863 73.766 77.3863H58.949C52.4523 77.3863 50.9706 76.2493 42.9922 75.1124V55.7846C48.5771 55.7846 57.8092 45.5522 57.8092 36.4567C57.8092 32.8618 62.7991 31.5225 64.6478 38.0916C65.7876 42.1414 62.3683 50.0999 62.3683 50.0999H80.6046C82.4944 50.0999 84.0239 51.6257 84.0239 53.5107C84.0239 55.3957 82.4944 58.0584 80.6046 58.0584H78.3251C80.2148 58.0584 81.7444 59.5842 81.7444 61.4692C81.7444 63.3543 80.2148 64.88 78.3251 64.88H76.0455",
    stroke: "#05C3DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 32,
    width: 56,
    height: 49
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7695 80.8311H85.7695V32.6004H30.7695V80.8311Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6426 79.9702H42.9918V52.4098H31.6426V79.9702Z",
    stroke: "#05C3DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0634 73.941C38.3406 73.941 37.7539 74.5198 37.7539 75.2329C37.7539 75.946 38.3406 76.5248 39.0634 76.5248C39.7863 76.5248 40.373 75.946 40.373 75.2329C40.373 74.5198 39.7863 73.941 39.0634 73.941Z",
    fill: "#05C3DE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSet);
export default __webpack_public_path__ + "static/media/allSet.5cf57dd0ce8344254bd233cddd8ae30c.svg";
export { ForwardRef as ReactComponent };